import { render, staticRenderFns } from "./CarPreview.vue?vue&type=template&id=16db7f3e&scoped=true&"
import script from "./CarPreview.vue?vue&type=script&lang=js&"
export * from "./CarPreview.vue?vue&type=script&lang=js&"
import style0 from "./CarPreview.vue?vue&type=style&index=0&id=16db7f3e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16db7f3e",
  null
  
)

export default component.exports